/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.15.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors, globalThemeConstants } from '../../../../../theme';
import { IAttrStyled } from '../../../../../types/globalTypes';

export const WidgetMainContainerStyled = styled.div.attrs({
    className: 'widget-container',
})`
    min-width: ${globalThemeConstants.minSiteWidth};
    max-width: ${globalThemeConstants.maxSiteWidth};
    margin: 0 auto;
`;

export const WidgetBlockStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `widget-block ${className || ''}`,
}))<IAttrStyled>`
    position: relative;
    max-width: 384px;
    width: 100%;
    padding: 24px;
    margin-bottom: 24px;
    box-sizing: border-box;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.09);
    background-color: ${colors.pageDashboardWidgetBlockBgColor};
`;
